<template>
	<div class="page">
		<!-- 头部 -->
		<Header :index="1" @login="login"></Header>
		<!-- 面包屑导航 -->
		<div class="sec_top_position">
			<div class="curPosition">
				<img src="@/assets/img/fruit-transfer/icon14.png">
				您所在的位置：<a :href= "homeHref">首页</a> &gt;
		     <a href="#" class="">成果转化</a>
			</div>
		</div>
		<!-- 查询按钮框 -->
		<div class="query-con">
			<div class="query-con-input">
				<el-input v-model="queryValue" placeholder="请输入成果名称" clearable></el-input>
				<el-button type="primary" icon="el-icon-search" @click="queryData">查询</el-button>
				<el-button @click="resetQuery" icon="el-icon-refresh" style="margin-left:0.3rem;">重置</el-button>
			</div>
		</div>
		<!-- 查询条件选择 -->
		<div class="query-condition">
			<!-- 科技领域 -->
			<div class="query-condition-box">
				<div class="qc-aside">科技领域</div>
				<div :class="!isShowTechnolog ? 'qc-rightbox-unpold' : 'qc-rightbox-up'">
					<div class="qc-rightbox-one">
						<el-checkbox :indeterminate="technology.isIndeterminate" v-model="technology.checkAll" @change="handlecheckAllChange(technology.checkAll,technology)" class="difference">全部</el-checkbox>
						<el-checkbox-group v-model="technology.checked">
						    <el-checkbox v-for="(item1,i) in technology.checkboxList"  :label="item1.code" :key="item1.code" @change="secondCheckedChange(technology.checked,technology,item1.code)">{{item1.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
					<div class="qc-rightbox-two" v-if="isDomain">
						<el-checkbox :indeterminate="secondArr.isIndeterminate" v-model="secondArr.checkAll" @change="handlecheckAllChange(secondArr.checkAll,secondArr)" class="difference" style="margin-right:20px;">全部</el-checkbox>
						<el-checkbox-group v-model="secondArr.checked" @change="handleCheckedChange(secondArr.checked,secondArr)" style="margin-left:0;">
						    <el-checkbox v-for="(item1,i) in secondArr.checkboxList" :label="item1.code" :key="item1.code">{{item1.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="upcontent" @click="technologyupUnfold">
					<span>{{!isShowTechnolog ? '展开' : '收起'}}</span>
					<i class="el-icon-caret-top" :class="[!isShowTechnolog ? 'el-icon-caret-bottom' : 'el-icon-caret-top']"></i>
				</div>
			</div>
			<!-- 成果阶段 -->
			<div class="query-condition-box">
				<div class="qc-aside">成果阶段</div>
				<div class="qc-rightbox">
					<div class="qc-rightbox-one">
						<el-checkbox :indeterminate="fruitPhase.isIndeterminate" v-model="fruitPhase.checkAll" @change="handlecheckAllChange(fruitPhase.checkAll,fruitPhase)" class="difference">全部</el-checkbox>
						<el-checkbox-group v-model="fruitPhase.checked" @change="handleCheckedChange(fruitPhase.checked,fruitPhase)">
						    <el-checkbox v-for="(item1,i) in fruitPhase.checkboxList" :label="item1.code" :key="item1.code">{{item1.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			<!-- 转化方式 -->
			<div class="query-condition-box">
				<div class="qc-aside">转化方式</div>
				<div class="qc-rightbox">
					<div class="qc-rightbox-one">
						<el-checkbox :indeterminate="transferMode.isIndeterminate" v-model="transferMode.checkAll" @change="handlecheckAllChange(transferMode.checkAll,transferMode)" class="difference">全部</el-checkbox>
						<el-checkbox-group v-model="transferMode.checked" @change="handleCheckedChange(transferMode.checked,transferMode)">
						    <el-checkbox v-for="(item1,i) in transferMode.checkboxList" :label="item1.code" :key="item1.code">{{item1.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			<!-- 意向价格 -->
			<div class="query-condition-box">
				<div class="qc-aside">意向价格</div>
				<div class="qc-rightbox">
					<div class="qc-rightbox-one">
						<el-checkbox :indeterminate="intentionPrice.isIndeterminate" v-model="intentionPrice.checkAll" @change="handlecheckAllChange(intentionPrice.checkAll,intentionPrice)" class="difference">全部</el-checkbox>
						<el-checkbox-group v-model="intentionPrice.checked" @change="handleCheckedChange(intentionPrice.checked,intentionPrice)">
						    <el-checkbox v-for="(item1,i) in intentionPrice.checkboxList" :label="item1.code" :key="item1.code">{{item1.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			<!-- 所在市州 -->
			<div class="query-condition-box">
				<div class="qc-aside">所在市州</div>
				<div :class="!isShowCity ? 'qc-rightbox-unpold' : 'qc-rightbox-up'">
					<div class="qc-rightbox-one">
						<el-checkbox :indeterminate="city.isIndeterminate" v-model="city.checkAll" @change="handlecheckAllChange(city.checkAll,city)" class="difference">全部</el-checkbox>
						<el-checkbox-group v-model="city.checked" @change="handleCheckedChange(city.checked,city)">
						    <el-checkbox v-for="(item1,i) in city.checkboxList" :label="item1.code" :key="item1.code">{{item1.name}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="upcontent" @click="cityupUnfold">
					<span>{{!isShowCity ? '展开' : '收起'}}</span>
					<i class="el-icon-caret-top" :class="[!isShowCity ? 'el-icon-caret-bottom' : 'el-icon-caret-top']"></i>
				</div>
			</div>
		</div>
		<div class="query-result">
			<!-- 排序的条件 -->
			<div class="dataSort">
				<div style="margin-top: 0.02rem;font-size:0.187rem;">综合排序</div>
				<div class="dataSort-el">
					发布时间
					<span class="caret-wrapper">
						<i class="el-icon-caret-top" :style="{color:[ordering === 'PUBLISH_TIME' ? 'red': '']}" @click="listOrdering('PUBLISH_TIME')"></i>
						<i class="el-icon-caret-bottom" :style="{color:[ordering === 'PUBLISH_TIME DESC' ? 'red': '']}"   style="margin-top: -0.05rem;" @click="listOrdering('PUBLISH_TIME DESC')"></i>
					</span>
				</div>
				<div class="dataSort-el">
					意向价格
					<span class="caret-wrapper">
						<i class="el-icon-caret-top" :style="{color:[ordering === 'INTENTION_PRICE_CODE' ? 'red': '']}"   @click="listOrdering('INTENTION_PRICE_CODE')"></i>
						<i class="el-icon-caret-bottom" :style="{color:[ordering === 'INTENTION_PRICE_CODE DESC' ? 'red': '']}"   style="margin-top: -0.05rem;" @click="listOrdering('INTENTION_PRICE_CODE DESC')"></i>
					</span>
				</div>
				<div class="dataSort-el">
					浏览量
					<span class="caret-wrapper">
						<i class="el-icon-caret-top" :style="{color:[ordering === 'VIEW_NUM' ? 'red': '']}"   @click="listOrdering('VIEW_NUM')"></i>
						<i class="el-icon-caret-bottom" :style="{color:[ordering === 'VIEW_NUM DESC' ? 'red': '']}"   style="margin-top: -0.05rem;" @click="listOrdering('VIEW_NUM DESC')"></i>
					</span>
				</div>
			</div>
			<!-- 查询出的列表 -->
			<div class="query-list" v-for="(item,index) in queryList" :key="index">
				<img :src="item.src"/>
				<div class="list-content">
					<div class="query-list-title cursor" @click="goDetail(item.id)">{{item.fruitName }}</div>
					<el-row :gutter="30">
					  <el-col :span="12"><div class="colfont">成果阶段：{{item.fruitStageName}}</div></el-col>
					  <el-col :span="12"><div class="colfont">转化方式：{{item.wayNames}}</div></el-col>
					</el-row>
					<div class="query-list-detail" v-if="!loginFlag">登录后可查看</div>
					<div class="query-list-detail" v-if="loginFlag">{{item.fruitIntroduction}}</div>
				</div>
				<div class="consult">
					<div class="consult-left">
						<div class="consult-left-text">意向价格</div>
						<div class="full">{{item.intentionPriceName }}</div>
					</div>
					<div class="consult-right">
						<el-button type="warning"  @click="showContact(item)">我要咨询</el-button>
						<div class="consult-right-text">点击我要咨询获取联系方式</div>
					</div>
				</div>

			</div>
			<!-- 弹出框 -->
			<el-dialog title="联系方式" :visible.sync="dialogVisible" width="16%" top="25vh">
				<div class="dialog-text">联系人：{{contactItem.contactPerson }}</div>
				<div class="dialog-text">联系电话：{{contactItem.contactPhone }}</div>
			</el-dialog>
			<!-- 分页 -->
			<div class="row-r" style="padding-bottom:0.15rem;">
				<el-pagination
						small
						layout="slot"
						:total="pageParam.pageTotal"
						:current-page="pageParam.page"
						:page-size="pageParam.pageSize"
						:page-sizes="[5, 10, 20, 50, 100]"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange">
					<span class="el-pagination__total">跳转至第<el-input v-model="pageValue" style="width:36px;" @change="jumper"></el-input>页</span>
				</el-pagination>
				<el-pagination
						small
						layout="slot"
						:total="pageParam.pageTotal"
						:current-page="pageParam.page"
						:page-size="pageParam.pageSize"
						:page-sizes="[5, 10, 20, 50, 100]"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange">
					<button :disabled="pageParam.page == pageParam.pageTotal" @click="toLastPage" style="cursor:pointer;margin-left: -11px;">尾页</button>
				</el-pagination>
				<el-pagination
					small
					layout="total,slot,prev,next"
					prev-text="上页"
					next-text="下页"
					@prev-click="prevClick"
					@next-click="nextClick"
					:total="pageParam.pageTotal"
					:current-page="pageParam.page"
					:page-size="pageParam.pageSize"
					:page-sizes="[5, 10, 20, 50, 100]"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange">
				<span class="el-pagination__total">，每页10条，页次 {{ pageParam.page }} / {{ Math.ceil(pageParam.pageTotal/10) }} 页</span>
				<button :disabled="pageParam.page == 1" @click="toFirstPage" style="cursor:pointer;margin-left:-5px;">首页</button>
			</el-pagination>

			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import queryConditionService from "@/api/platform-declare/fruit-transfer"
	import fileService from "@/api/file/fileApi"
	import  dictConst  from '@/api/platform-declare/constant/dictConst'
	import setRemPc from '@/api/setrem'
	import Header from '@/views/platform/components/header.vue'
	import Footer from '@/views/platform/components/footer.vue'
	export default {
		components:{
			Header,
			Footer
		},
		data(){
			return{
				homeHref: process.env.VUE_APP_NAV_BASE_URL + 'ch00108/',
				loginFlag:false,
				pageValue:'',
				dialogVisible:false,
				contactItem:{
					contactPerson:'',
					contactPhone:''
				},
				queryValue:'',
				isDomain: false, //科技领域中的二级显示开关
				secondArr: {
				  isIndeterminate: false,
				  checked: [],
				  checkboxList: []
				},
				technology: {
				  isIndeterminate: false,
				  checkAll: false,
				  checked: [],
				  checkboxList: []
				},
				fruitPhase: {
				  isIndeterminate: false,
				  checkAll: false,
				  checked: [],
				  checkboxList: [],
				},
				transferMode: {
				  isIndeterminate: false,
				  checkAll: false,
				  checked: [],
				  checkboxList: [ ],
				},
				intentionPrice: {
				  isIndeterminate: false,
				  checkAll: false,
				  checked: [],
				  checkboxList: [],
				},
				city: {
				  isIndeterminate: false,
				  checkAll: false,
				  checked: [],
				  checkboxList: []
				},
			    pageParam: {
			      page: 1,
			      pageSize: 10,
				  pageTotal: 0,
			    },
				isShowTechnolog: false, //科技领域展开收起开关
				isShowCity: false,//城市展开收起开关
				queryList:[],
				ordering:''
			}
		},
		created(){
		    // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题
			setRemPc();
            window.addEventListener('resize', setRemPc);//浏览器窗口大小改变时调用rem换算方法
			this.querySubmitData();

            //字典条件初始化
            this.buildDictConditional();
		},
		methods: {
			//接收header传过来的是否登录信息
			login(param){
				this.loginFlag = param;
			},
			//显示联系方式
			showContact(item){
				if(this.loginFlag){
					this.contactItem = item
					this.dialogVisible = true
				} else {
					this.$message({
					    showClose: true,
					    message: '咨询前，请先登录',
					    type: 'warning'
					});
				}
			},
			//排序
			listOrdering(arg){
				this.ordering = arg
				this.querySubmitData()
			},
			//查询按扭请求
			queryData(){
				this.pageParam.page = 1
				this.querySubmitData()
			},
			//数据请求
			querySubmitData(){
				let params = {
				  cityCodes: this.city.checked,
				  intentionPriceCodes: this.intentionPrice.checked,
				  techDomainCodes: this.technology.checked,
				  techDomainCodesSecond :this.secondArr.checked,
				  wayCodes: this.transferMode.checked,
				  stageCodes: this.fruitPhase.checked,
				  pageNum: this.pageParam.page,
				  pageSize: this.pageParam.pageSize,
				  keywords: this.queryValue,
				  orderby: this.ordering
				}
				queryConditionService
				    .fruitTransferList(params)
				    .then(res => {
						//console.log('科技创新',res);
				      this.queryList = res.data.list
				      this.pageParam.pageTotal = res.data.total;
				      if(res.data.list.length === 0){
						  this.$alert('抱歉，未能找到您想要的信息!', '192.168.15.45显示', {
							  confirmButtonText: '确定'
						  });
					  }
					  for(let i=0; i<this.queryList.length; i++){
						  if(this.queryList[i].files && this.queryList[i].files.length>0){
							  this.queryList[i].src = fileService.getUrl(this.queryList[i].files[0].fileId)
						  } else {
							  this.queryList[i].src = require('@/assets/img/fruit-transfer/listimg.jpg')
						  }
					  }
				    })
				    .catch(error => {
				      console.log('error',error);
				    })
				    .finally(() => {
				      this.loading = false;
				    });
			},

      //获取科技领域，成果阶段，转换方式、意向价格、所在市州
      buildDictConditional() {
        let this_=this;
        let domains = [];
        let fruitPhases=[];
        let translateTypes=[];
        let intentionPrices=[];
        let citys = [];
		let domainsTmp = {};
        const dicts=[dictConst.techDomain,dictConst.fruitPhase,dictConst.translateType,dictConst.intentionPrice,dictConst.region];
        queryConditionService
            .getDictData({"dictCodeList":dicts.join(',')})
            .then(
                res => {
                  //console.log("结果看是什么", res);
                  if(!res || !res.data || !res.data.rows || res.data.rows.length==0){
                    return;
                  }
                  let dicts = res.data.rows;
                  for (let i = 0; i < dicts.length; i++) {
                    let dict = dicts[i];

                    //地域-市州
                    if (dict.dictCode === dictConst.region && dict.parentCode === dictConst.regionHunanCode) {
                      let bigCity = {"code": dict.itemCode, "name": dict.itemValue,"children": []};
                      citys.push(bigCity);
                      continue;
                    }
                    //领域  一级
                    // if (dict.dictCode === dictConst.techDomain) {
                    //   if (dict.parentCode == null || dict.parentCode == undefined) {
                    //     let bigDomain = { "code": dict.itemCode,  "name": dict.itemValue, "children": [] };
                    //     domains.push(bigDomain);
                    //   }
                    //   continue;
                    // }
					
					//领域 children
					if (dict.dictCode === dictConst.techDomain) {
					  if (dict.parentCode == null || dict.parentCode == undefined) {
					    let bigDomain = { "code": dict.itemCode,  "name": dict.itemValue, "children": [] };
					    domains.push(bigDomain);
					    domainsTmp[dict.itemCode] = bigDomain;
					  } else {
					    let smallDomain = { "code": dict.itemCode, "name": dict.itemValue };
					    let bigDomain = domainsTmp[dict.parentCode];
					    if (bigDomain == null || bigDomain == undefined) {
					      bigDomain = { "code": dict.parentCode, "name": "", "children": [] };
					      domains.push(bigDomain);
					      domainsTmp[dict.itemCode] = bigDomain;
					    }
					    bigDomain.children.push(smallDomain);
					  }
					  continue;
					}

                    //阶段
                    if (dict.dictCode === dictConst.fruitPhase){
                      fruitPhases.push({  "code": dict.itemCode,  "name": dict.itemValue  });
                      continue;
                    }
                    //转换类型
                    if (dict.dictCode === dictConst.translateType){
                      translateTypes.push({  "code": dict.itemCode,  "name": dict.itemValue  });
                      continue;
                    }
                    //意向价格
                    if (dict.dictCode === dictConst.intentionPrice){
                      intentionPrices.push({  "code": dict.itemCode,  "name": dict.itemValue  });
                      continue;
                    }
                  }
                  // 将组装好的字典给页面变量 technology fruitPhase transferMode intentionPrice city

				  for(let i=0; i<domains.length; i++){
					if(domains[i].name === "待定"){
						domains.splice(i,1)
						break;
					}
				  }
				  
				  this_.technology.checkboxList=domains;
                  this_.fruitPhase.checkboxList=fruitPhases;
                  this_.transferMode.checkboxList=translateTypes;
                  this_.intentionPrice.checkboxList=intentionPrices;
                  this_.city.checkboxList=citys;
                }
            )
            .catch(
                res => {
                  console.log("结果catch", res);
                }
            )
            .finally(() => {
            })
      },

			//查询条件全部事件
			handlecheckAllChange(val, type) {
			  type.checked = val ? type.checkboxList.map(item => item.code) : [];
			  type.isIndeterminate = false
			},
			//查询条件选择事件
			handleCheckedChange(value, type) {
					  //console.log('a', value);
			  let checkedCount = value.length;
			  type.checkAll = checkedCount === type.checkboxList.length;
			  type.isIndeterminate = checkedCount > 0 && checkedCount < type.checkboxList.length;
			},
			//以下二个方法均为展开收起事件
			technologyupUnfold() {
			  this.isShowTechnolog = !this.isShowTechnolog
			},
			//科技领域查询条件单选事件
			secondCheckedChange(value, type, code) {
			  // console.log('科技领域', value);
			  if (value.includes(code)) {
			    for (let i = 0; i < type.checkboxList.length; i++) {
			      if (code === type.checkboxList[i].code) {
			        this.isDomain = true
			        this.secondArr.checkboxList = type.checkboxList[i].children
			      }
			    }
			  } else {
			    this.isDomain = false
					  this.secondArr.checked = []
			  }
			  
			},
			resetQuery(){
				this.queryValue = ''
				this.technology.checked = []
				this.secondArr.checked = []
				this.fruitPhase.checked = []
				this.transferMode.checked = []
				this.intentionPrice.checked = []
				this.city.checked = []
				this.queryData()
			},
			cityupUnfold() {
			  this.isShowCity = !this.isShowCity
			},
			goDetail(param){
				let { href } = this.$router.resolve({
				        path: '/platform/fruit-transfer/detail',
				        query: {
				          id: param
				        }
				      })
				window.open(href, '_blank')
				
				// this.$router.push({
				//   path: '/platform/fruit-transfer/detail',
				//   query: {
				//     id: param
				//   }
				// })
			},
			//每页数变化
			handleSizeChange(pageSize) {
			  this.pageParam.page = 1;
			  this.pageParam.pageSize = pageSize;
			  this.querySubmitData();
			},
			//页码变化
			handleCurrentChange(currentPage) {
			  this.pageParam.page = currentPage;
			  this.querySubmitData();
			},
			//前往首页
			toFirstPage() {
				this.handleCurrentChange(1);
			},
			//  前往末页
			toLastPage() {
				let max = Math.ceil(this.pageParam.pageTotal / this.pageParam.pageSize);
				this.handleCurrentChange(max);
			},
			//跳转到第几页
			jumper(){
				this.handleCurrentChange(this.pageValue);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import url('~@/assets/css/breadnav.css');
	.page{
		font-size: 0.18rem;
		padding: 0;
		margin: -8px;
		background-color: #F5F5F5;
	}
	.w{
		width: 15.7rem;
		margin: 0 auto;
	}
	.q-display{
		display: flex;
		flex-direction: row;
	}
	.q-align{
		justify-content: center;
	}
	.q-sxalign{
		justify-content: center;
		align-items: center;
	}
	.qc-aside{
		@extend .q-display;
		@extend .q-sxalign;
		width: 1.35rem;
		font-size: 0.18rem;
		font-weight: 500;
		color: #333333;
		border-bottom: 0.01rem solid #E9E9E9;
	
	}
	::v-deep .query-con{
		@extend .w;
		background-color: #ffffff;
		margin-top:0.25rem;
		padding: 0.2rem 0;
		&-input{
			@extend .q-display;
			@extend .q-align;
			.el-input{
				width: 60%;
				height: 0.4rem !important;
				font-size: 0.16rem;
			}
			.el-input__inner{
				height:0.47rem !important;
				line-height: 0.5rem;
			}
			.el-button{
				height:0.47rem !important;
				margin-left: -0.08rem;
				font-size: 0.18rem;
			}
		}
	}
	.query-condition{
		@extend .w;
		background: #ffffff;
		// box-shadow: 0 0.02rem 0.02rem 0 rgba(0,0,0,0.05);
		&-box{
			@extend .q-display;
			position: relative;
			background: #ffffff;
			.qc-text{
				width: 0.6rem;
			}
			.upcontent{
				position: absolute;
				top:0.14rem;
				right:0.08rem;
				font-size: 0.16rem;
				font-weight: 400;
				color: #4CA9FF;
				cursor: pointer;
			}
		}
	}
	::v-deep .difference{
		height: 0.33rem;
		color: #ffffff;
		padding: 0 0.15rem 0 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-radius: 0.2rem 0.2rem;
		background-color: #4CA9FF;
		.el-checkbox__input {
		    opacity: 0;
		}
		.el-checkbox__label {
		    font-size: 0.16rem;
		    margin-left:-14px;
		}
		.el-checkbox__input.is-checked+.el-checkbox__label {
		    color: #ffffff;
		}
	}
	::v-deep .difference1{
		height: 0.55rem;
		margin-top: 0.05rem;
		color: #ffffff;
		padding: 0.1rem 0.1rem 0.1rem 0.03rem;
		box-sizing: border-box;
		border-radius: 0.08rem;
		background-color: #4CA9FF;
		.el-checkbox__input {
		    opacity: 0;
		}
		.el-checkbox__label {
		    margin-left:-17px;
		}
		.el-checkbox__input.is-checked+.el-checkbox__label {
		    color: #ffffff;
		}
	}
	.qc-font{
		padding: 0.15rem 0.2rem 0.1rem 0.2rem;
		font-size: 0.16rem;
		font-weight: 400;
		line-height: 0.31rem;
		color: #4A4A4A;
		box-sizing: border-box;
	}
	.qc-rightbox{
		@extend .qc-font;
		border-bottom: 0.01rem solid #E9E9E9;
		flex: 1;
		&-one{
			@extend .q-display;
		}
		&-two{
			@extend .q-display;
			@extend .qc-font;
			margin-left:0.5rem;
			background: rgba(245,166,35,0.12);
			border-radius: 0.04rem 0.04rem;
		}
	}
	.qc-rightbox-up{
		@extend .qc-font;
		border-bottom: 0.01rem solid #E9E9E9;
		flex: 1;
		min-height: 0.5rem;
		&-one{
			@extend .q-display;
		}
		&-two{
			@extend .q-display;
			@extend .qc-font;
			margin-left:0.5rem;
			background: rgba(245,166,35,0.12);
			border-radius: 0.04rem 0.04rem;
		}
	}
	.qc-rightbox-unpold{
		@extend .qc-font;
		border-bottom: 0.01rem solid #E9E9E9;
		flex: 1;
		max-height: 0.58rem;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		&-one{
			@extend .q-display;
		}
		&-two{
			@extend .q-display;
			@extend .qc-font;
			margin-left:0.5rem;
			background: rgba(245,166,35,0.12);
			border-radius: 0.04rem 0.04rem;
		}
	}
	.query-result {
	  @extend .w;
	  padding: 0.2rem 0.1rem 0 0.3rem;
	  background-color: #ffffff;
	  box-sizing: border-box;
	}
	.dataSort{
		@extend .q-display;
		font-size: 0.18rem;
		color:#000000;
		font-weight: bold;
		margin-bottom: 0.3rem;
		&-el {
			margin-left:0.3rem;
		}
	}
	.caret-wrapper {
	    display: inline-flex;
	    flex-direction: column;
	    // align-items: center;
	    height: 0.34rem;
	    width: 0.34rem;
	    vertical-align: middle;
	    cursor: pointer;
	    overflow: initial;
	    position: relative;
	}
	.caret-wrapper i {
	    color: #3E9FFF;
	}
	.query-list{
		@extend .q-display;
		margin: 0.15rem 0;
		img {
			width: 3.3rem;
			height:2.2rem;
		}
	}
	.list-content{
		flex: 1;
		border: 0.01rem solid #F9F9F9;
		box-sizing: border-box;
		padding: 0.2rem 0.1rem 0.1rem 0.3rem;
	}
	::v-deep .consult{
		@extend .q-display;
		align-items: center;
		width: 2.9rem;
		&-left {
			width: 40%;
			text-align: center;
			&-text{
				font-size: 0.18rem;
				color: #858585;
			}
		}
		&-right {
			flex: 1;
			text-align: center;
			.el-button {
			    padding: 0.14rem 0.2rem !important;
			    border-radius: 0.03rem !important;
				font-size: 0.2rem !important;
			}
			&-text{
				font-size: 0.16rem;
				color: #858585;
				margin-top:0.1rem;
			}
		}
		.full{
			font-size: 0.22rem;
			font-weight: bold;
			margin-bottom: 0.1rem;
		}
	}
	
	.cursor{
		cursor: pointer;
	}
	.cursor:hover{
		color:#ff0000;
	}
	.query-list-title{
		font-size: 0.22rem;
		font-weight: 500;
		color: #479CF5;
		line-height: 0.4rem;
		margin-bottom: 0.2rem;
	}
	.query-list-tag{
		@extend .q-display;
	}
	.colfont{
		font-size: 0.18rem;
	}
	.query-list-detail{
		font-size: 0.17rem;
		line-height: 0.3rem;
		color:#848484;
		margin-top:0.2rem;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		-webkit-box-orient: vertical;
		word-break: break-all ;
	}
	.dialog-text{
		font-size: 0.2rem;
		line-height: 0.4rem;
	}
	::v-deep .el-checkbox-group{
		margin-left: 0.35rem;
	}
	::v-deep .el-checkbox__label{
		font-size: 0.18rem;
		line-height: 0.3rem;
	}
	::v-deep .el-dialog__title{
		color:#ffffff;
	}
	::v-deep .el-dialog__headerbtn .el-dialog__close{
		color:#ffffff;
	}
	::v-deep .el-input__inner:hover{
		font-size: 0.16rem !important;
	}
	::v-deep .el-input--suffix .el-input__inner {
	    padding-right: 0.2rem;
	}
	::v-deep .el-input__inner {
		font-size: 0.16rem !important;
	}
	::v-deep  .el-pagination .el-select .el-input .el-input__inner {
		height: 22px !important;
		font-size: 13px !important;
	}
	::v-deep  .el-pagination__editor.el-input .el-input__inner {
		height: 22px !important;
	}
	::v-deep .el-select .el-input .el-select__caret {
		line-height: 40px !important;
	}

	::v-deep .el-pagination .el-input__inner{
		border-radius: 0 0;
		height: 20px !important;
	}
	.activeClass{
		color:#ff0000;
	}
</style>
<style>
	.el-message__icon {
		font-size: 0.26rem !important;
	}
	.el-message-box__wrapper::after {
		vertical-align: top;
		background-color: rgba(255,255,255,0);
	}
	.v-modal {
		background: rgba(0,0,0,0);
	}
	.el-pagination .btn-prev {
		padding-right: 0px;
	}
	.el-pagination .btn-next {
		padding-left: 0px;
	}
	.el-pagination--small button, .el-pagination--small span:not([class*=suffix]) {
		line-height: 30px;
	}
	.el-input__inner{
		padding:0 5px;
	}
</style>